import TemplateContact from './TemplateContact'

export default TemplateContact
